import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import QuoteForm from "@/components/QuoteForm";
import { IMAGES, fadeInUp, staggerContainer } from "@/lib/constants";

const HeroSection = () => {
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <section id="home" data-testid="hero-section" className="relative min-h-screen flex items-center bg-[#F9F9F7]">
      <div className="absolute inset-0 overflow-hidden">
        <motion.img
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.5 }}
          src={IMAGES.hero}
          alt="Modern bathroom with glass shower"
          className="w-full h-full object-cover opacity-30"
        />
      </div>
      <div className="section-container relative z-10 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center py-32">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
            className="max-w-2xl"
          >
            <motion.span
              variants={fadeInUp}
              className="inline-block font-accent text-sm font-semibold tracking-widest uppercase text-[#0F4C81] mb-6"
            >
              Trusted Since 1994
            </motion.span>
            <motion.h1
              variants={fadeInUp}
              className="font-heading text-5xl md:text-7xl font-medium tracking-tight leading-[1.1] text-[#1A202C] mb-6"
            >
              The Clear Choice for Quality Glass
            </motion.h1>
            <motion.p
              variants={fadeInUp}
              className="font-body text-lg md:text-xl leading-relaxed text-[#4B5563] mb-10 max-w-lg"
            >
              Serving coastal North Carolina with precision craftsmanship for over 30 years. Custom showers, mirrors, and commercial solutions.
            </motion.p>
            <motion.div variants={fadeInUp} className="flex flex-wrap gap-4">
              <Dialog open={quoteOpen} onOpenChange={setQuoteOpen}>
                <DialogTrigger asChild>
                  <Button
                    data-testid="hero-quote-btn"
                    className="bg-[#0F4C81] hover:bg-[#0A355C] text-white rounded-full px-8 h-14 font-body font-semibold text-base transition-all duration-300 hover:scale-105 flex items-center gap-2"
                  >
                    Get a Free Quote
                    <ArrowRight className="w-5 h-5" />
                  </Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-[500px] p-8">
                  <DialogHeader>
                    <DialogTitle className="font-heading text-2xl text-[#1A202C]">Request a Free Quote</DialogTitle>
                  </DialogHeader>
                  <QuoteForm onClose={() => setQuoteOpen(false)} />
                </DialogContent>
              </Dialog>
              <a href="#services">
                <Button
                  data-testid="hero-services-btn"
                  variant="outline"
                  className="border-2 border-[#1A202C] text-[#1A202C] hover:bg-[#1A202C] hover:text-white rounded-full px-8 h-14 font-body font-semibold text-base transition-all duration-300"
                >
                  View Services
                </Button>
              </a>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
